import { forwardRef } from 'react';
var FormLayout = forwardRef(function (_a, ref) {
    var children = _a.children;
    return (<div ref={ref} className={'relative h-full flex-1 overflow-auto'}>
      {children}
    </div>);
});
export default FormLayout;
